<form class="app-form" [formRoot]="form">
  <div class="setup-content" id="step-4">
    <h4>{{ 'MESSAGES.INFOS.LETS_KEEP_YOU_SECURE' | translate }}</h4>
    <p>{{ 'MESSAGES.PROMPTS.CREATE_STRONG_PASSWORD' | translate }}</p>
    <div class="form-group">
      <label class="col-form-label">{{ 'LABELS.PASSWORD' | translate }}</label>
      <div class="relative" data-field-wrapper>
        <input
          class="form-control pr-16"
          [formField]="form.password"
          placeholder="{{ 'PLACEHOLDERS.ENTER_PASSWORD' | translate }}"
          autocomplete="new-password"
          [type]="revealPassword() ? 'text' : 'password'"
          appFormFieldOnError
          [customMessages]="{
            required: 'MESSAGES.ERRORS.PASSWORD_REQUIRED' | translate,
            minlength: 'PASSWORD_RESET.PASSWORD_MIN_LENGTH' | translate,
            pattern: 'PASSWORD_RESET.PASSWORD_OTHER_REQUIREMENTS' | translate,
          }"
        />
        <app-password-visibility-toggle [revealed]="revealPassword()" (toggled)="togglePasswordVisibility()" />
      </div>
    </div>
    <div class="form-group">
      <label class="col-form-label">{{ 'LABELS.CONFIRM_PASSWORD' | translate }}</label>
      <input
        class="form-control"
        [formField]="form.confirmPassword"
        placeholder="{{ 'MESSAGES.PROMPTS.ENTER_PASSWORD' | translate }}"
        autocomplete="new-password"
        type="password"
        appFormFieldOnError
        [customMessages]="{
          required: 'MESSAGES.ERRORS.PASSWORD_CONFIRMATION_REQUIRED' | translate,
          minlength: 'MESSAGES.ERRORS.CONFIRM_PASSWORD_MIN_LENGTH' | translate,
          pattern: 'MESSAGES.ERRORS.CONFIRM_PASSWORD_OTHER_REQUIREMENTS' | translate,
          passwordMismatch: 'MESSAGES.ERRORS.PASSWORDS_DO_NOT_MATCH' | translate,
        }"
      />
    </div>
    <div class="form-group mb-0">
      <button
        class="btn btn-gradient float-right mt-4"
        type="submit"
        [disabled]="form().invalid() || form().submitting()"
      >
        {{ 'LABELS.CREATE_ACCOUNT' | translate }}
      </button>
      <button class="btn btn-outline-secondary float-right mr-4 mt-4" type="button" (click)="back.emit()">
        {{ 'LABELS.BACK' | translate }}
      </button>
    </div>
  </div>
</form>
